export enum OccupationType {
  NO_FILTER = "0",
  PER_PERSON = "1",
  FOR_ADULTS_CHILDREN = "2",
  FOR_ADULTS_CHILDREN_BABIES = "3",
  FOR_ADULTS_TEENS_CHILDREN = "5",
  FOR_ADULTS_TEENS_CHILDREN_BABIES = "7",
  FOR_SENIORS_ADULTS_TEENS_CHILDREN_BABIES = "8",
}

export interface OccupancyProps {
  occupationType: OccupationType;
  minChildrenAge: number | null;
  maxChildrenAge: number | null;
  minBabiesAge: number | null;
  maxTeensAge: number | null;
  maxSeniorsAge: number | null;
  filterByAge: boolean;
}

export class OccupancyEntity {
  private constructor(
    readonly occupationType: OccupationType,
    readonly minChildrenAge: number | null,
    readonly maxChildrenAge: number | null,
    readonly minBabiesAge: number | null,
    readonly maxTeensAge: number | null,
    readonly maxSeniorsAge: number | null,
    readonly filterByAge: boolean
  ) {}

  static of(props: OccupancyProps) {
    return new OccupancyEntity(
      props.occupationType,
      props.minChildrenAge,
      props.maxChildrenAge,
      props.minBabiesAge,
      props.maxTeensAge,
      props.maxSeniorsAge,
      props.filterByAge
    );
  }
}
